// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_SettleInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Settle request body — the single shared shape M2's agent caller posts.
 *
 * Field names are FIXED here (M1b decision, binding on M2):
 *   cache_hit   (int) — raw cache-hit input tokens
 *   cache_miss  (int) — raw cache-miss input tokens
 *   output      (int) — raw output tokens
 *   model       (string) — AI model identifier
 *   request_id  (string) — idempotency key (chatId + userMessageId, M2)
 *   franquia_id (int) — billing franchise
 *
 * RAW token sums only — NO cost fields. The agent reports tokens;
 * app-api computes COGS via Ai_credit_pricing_model::priceUsage().
 *
 * No cache_hit_tokens / prompt_cache_hit_tokens variants — those names
 * are explicitly forbidden here so M2 cannot drift.
 */
import { registerContract } from './validate'

export interface AiCredits_SettleInput {
cache_hit: number
cache_miss: number
output: number
model: string
request_id: string
franquia_id: number
}

registerContract('AiCredits_SettleInput', {
  cache_hit:   { type: 'number',  required: true },
  cache_miss:  { type: 'number',  required: true },
  output:      { type: 'number',  required: true },
  model:       { type: 'string',  required: true },
  request_id:  { type: 'string',  required: true },
  franquia_id: { type: 'number',  required: true },
})
